import axios from "axios";
import { authorizedHeader } from "./authorization";
import {
  vehicleTravelledDistanceUrl,
  vehicleAutoTripsUrl,
  vehicleOverviewUrl,
  vehicleDataAvailabilityUrl,
  vehicleStatusDataUrl,
  vehicleCreateTestRideUrl,
} from "components/Common/endpoints";

export const getVehicleOverview = async (vehImei) => {
  const response = await axios({
    method: "GET",
    url: vehicleOverviewUrl,
    params: {
      imei: vehImei,
    },
    headers: authorizedHeader(),
  });
  return response.data;
};

export const getVehicleDistance = async (
  imei,
  selectedDateRange,
  datePickerType
) => {
  const response = await axios({
    method: "GET",
    url: vehicleTravelledDistanceUrl,
    params: {
      imei: imei,
      from: selectedDateRange[0],
      to: selectedDateRange[1],
      timeFilter: datePickerType.toUpperCase(),
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getVehicleTrips = async (
  vehImei,
  selectedDateRange,
  datePickerType,
  page, 
  size
) => {
  const response = await axios({
    method: "GET",
    url: vehicleAutoTripsUrl,
    params: {
      imei: vehImei,
      from: selectedDateRange[0],
      to: selectedDateRange[1],
      timeFilter: datePickerType.toUpperCase(),
      // tripType: "AUTOMATIC",
      page,
      size,
      sort: "id,desc",
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getVehicleDataAvailability = async (
  vIdVal,
  selectedDateRange,
  datePickerType,
  dataTable
) => {
  const response = await axios({
    method: "GET",
    url: vehicleDataAvailabilityUrl,
    params: {
      vIdVal,
      from: selectedDateRange[0],
      to: selectedDateRange[1],
      timeFilter: datePickerType.toUpperCase(),
      vehicleDataTable: dataTable.toUpperCase(),
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getVehicleStatusData = async (
  vIdVal,
  selectedDateRange,
  datePickerType
) => {
  const response = await axios({
    method: "GET",
    url: vehicleStatusDataUrl,
    params: {
      vIdVal,
      from: selectedDateRange[0],
      to: selectedDateRange[1],
      timeFilter: datePickerType.toUpperCase(),
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const createTestRideAPI = async (tripId) => {
  const response = await axios({
    method: "PUT",
    url: vehicleCreateTestRideUrl.replace("{tripId}", tripId),
    params: {},
    headers: authorizedHeader(),
  });
  return response?.data;
};